import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useTRPC } from "../trpc.js";
import { SUPPORT_SUBSCRIPTION_PRODUCT_IDS, TIERED_PRODUCT_IDS, type SupportProductId, type TieredPriceProductId } from "@project/common";

/**
 * Get first active base subscription
 * User that is development and partner or on trial do not have base subscription
 */
export const useProductIds = () => {
  const trpc = useTRPC();

  const {
    data: subscriptions = [],
    isLoading: isLoadingSubscriptions,
  } = useQuery(trpc.getCurrentSubscriptions.queryOptions(undefined, {
    refetchInterval: 1000 * 60 * 15,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 15,
  }));

  const tieredProductIds = useMemo(() => {
    return subscriptions
      .filter(subscription => subscription.status === "active")
      .flatMap(subscription => subscription.prices)
      .filter(price => TIERED_PRODUCT_IDS.includes(price.nickname as TieredPriceProductId))
      .map(price => price.nickname as TieredPriceProductId);
  }, [subscriptions]);

  const supportProductIds = useMemo(() => {
    return subscriptions
      .filter(subscription => subscription.status === "active")
      .flatMap(subscription => subscription.prices)
      .filter(price => SUPPORT_SUBSCRIPTION_PRODUCT_IDS.includes(price.nickname as SupportProductId))
      .map(price => price.nickname as TieredPriceProductId);
  }, [subscriptions]);

  return useMemo(() => ({
    isLoadingSubscriptions,
    tieredProductIds,
    supportProductIds,
  }), [isLoadingSubscriptions, tieredProductIds, supportProductIds]);
};
